const PERMISSION_FIELDS = [
  "profile",
  "allTicket",
  "allUserChat",
  "allHistoric",
  "allowGroup",
  "seeAllGroups",
];

export function computeOwnUserUpdate(currentUser, data, now = Date.now()) {
  if (!data || data.action !== "update" || !data.user) return null;
  if (!currentUser || data.user.id !== currentUser.id) return null;

  const groupAccessChanged = data.groupAccessChanged === true;
  const permissionsChanged =
    groupAccessChanged ||
    PERMISSION_FIELDS.some((field) => data.user[field] !== currentUser[field]);

  return {
    patch: {
      ...data.user,
      ...(groupAccessChanged ? { groupAccessVersion: now } : {}),
    },
    permissionsChanged,
  };
}
